// Mock data for International Yoga Retreat website
// Bilingual support: English (en) and Turkish (tr)

export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      retreats: "Retreats",
      services: "Services",
      whyUs: "Why Us",
      gallery: "Gallery",
      contact: "Contact",
      bookRetreat: "Book Retreat"
    },
    // Hero Section
    hero: {
      tagline: "International Retreat Camps",
      titlePart1: "Rediscover Your ",
      titleHighlight: "Inner Peace",
      titlePart2: " Through Transformational Journeys",
      subtitle: "Experience luxury wellness retreats that reconnect mind, body, and nature. Professional tourism services backed by ENC Holiday's expertise.",
      discoverRetreats: "Discover Retreats",
      planJourney: "Plan Your Journey",
      scroll: "Scroll"
    },
    // Why Us Section
    whyUs: {
      tagline: "Why Choose Us",
      title: "A Sacred Pause from Modern Life",
      subtitle: "Our retreats are not escapes — they are gateways to long-lasting transformation, combining ancient wisdom with luxury travel experiences."
    },
    // Featured Retreats
    featuredRetreats: {
      tagline: "Featured Retreats",
      title: "Begin Your Journey",
      viewAll: "View All Retreats",
      from: "From",
      learnMore: "Learn More",
      days: "Days"
    },
    // Our Story
    story: {
      tagline: "Our Story",
      title: "Where Ancient Wisdom Meets Modern Excellence",
      paragraph1: "Omar Sharif Retreats is more than a travel company — it's a philosophy of mindful living. We believe that yoga retreats are gateways to transformation, offering a sacred pause from the demands of modern life.",
      paragraph2: "Backed by ENC Holiday's professional tourism infrastructure, we guarantee quality service from booking to return, with contracted prices and personalized care.",
      quote: "Return to breath, nature, and inner balance.",
      learnStory: "Learn Our Story"
    },
    // CTA Section
    cta: {
      title: "Ready to Begin Your Transformation?",
      subtitle: "Let us craft your perfect wellness journey. From intimate retreats to group expeditions, we're here to guide every step.",
      exploreRetreats: "Explore Retreats",
      contactUs: "Contact Us"
    },
    // Features
    features: {
      authenticYoga: "Authentic Yoga",
      authenticYogaDesc: "Traditional practices from certified instructors",
      holisticWellness: "Holistic Wellness",
      holisticWellnessDesc: "Mind, body, and spirit in harmony",
      curatedDestinations: "Curated Destinations",
      curatedDestinationsDesc: "Handpicked locations worldwide",
      professionalService: "Professional Service",
      professionalServiceDesc: "Licensed agency backing every trip"
    },
    // Footer
    footer: {
      description: "Omar Sharif Retreats transformation-oriented yoga retreats and professional tourism services. With the assurance of ENC Holiday.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      copyright: "© 2026 Omar Sharif Retreats. Operated by ENC Holiday.",
      rights: "Licensed Travel Agency • All Rights Reserved"
    },
    // Contact Page
    contactPage: {
      tagline: "Get In Touch",
      title: "Contact Us",
      subtitle: "Ready to begin your transformation? We're here to help you plan your perfect wellness journey.",
      letsConnect: "Let's Connect",
      address: "Address",
      phone: "Phone",
      email: "Email",
      sendMessage: "Send Us a Message",
      name: "Name",
      namePlaceholder: "Your name",
      emailPlaceholder: "your@email.com",
      phonePlaceholder: "+1 (555) 000-0000",
      message: "Message",
      messagePlaceholder: "Tell us about your dream retreat...",
      send: "Send Message",
      thankYou: "Thank you for your message! We'll get back to you soon."
    },
    // Retreats Page
    retreatsPage: {
      tagline: "Our Retreats",
      title: "Transformational Journeys",
      subtitle: "Explore our carefully curated retreats designed to reconnect you with your inner self through yoga, meditation, and cultural immersion."
    },
    // About Page
    aboutPage: {
      tagline: "About Us",
      title: "Our Story",
      subtitle: "Where ancient wisdom meets modern excellence in transformational yoga journeys.",
      startJourney: "Start Your Journey"
    },
    // Services Page
    servicesPage: {
      tagline: "What We Offer",
      title: "Our Services",
      subtitle: "Comprehensive travel and wellness services backed by ENC Holiday's professional tourism expertise."
    },
    // Why Us Page
    whyUsPage: {
      tagline: "Why Choose Us",
      title: "A Sacred Pause",
      subtitle: "Our retreats are not escapes — they are gateways to long-lasting transformation.",
      professionalTitle: "Professional Tourism Excellence",
      professionalDesc: "Backed by ENC Holiday's professional tourism infrastructure, we guarantee quality service from booking to return, with contracted prices and personalized care. Our licensed agency ensures every aspect of your journey is handled with expertise and attention to detail.",
      happyTravelers: "Happy Travelers",
      destinations: "Destinations",
      yearsExperience: "Years Experience"
    },
    // Gallery Page
    galleryPage: {
      tagline: "Visual Journey",
      title: "Our Gallery",
      subtitle: "Explore moments of tranquility, transformation, and connection from our retreats around the world."
    }
  },
  tr: {
    // Navigation
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      retreats: "Yoga Kampları",
      services: "Hizmetlerimiz",
      whyUs: "Neden Biz?",
      gallery: "Galeri",
      contact: "İletişim",
      bookRetreat: "Rezervasyon Yap"
    },
    // Hero Section
    hero: {
      tagline: "Uluslararası İnziva ve Dönüşüm Kampları",
      titlePart1: "Dönüşüm Yolculuklarıyla ",
      titleHighlight: "İç Huzurunuzu",
      titlePart2: " Yeniden Keşfedin",
      subtitle: "Zihin, beden ve doğayla yeniden bağ kurmanızı sağlayan lüks wellness kamplarını deneyimleyin. ENC Holiday güvencesiyle profesyonel turizm hizmetlerinin tadını çıkarın.",
      discoverRetreats: "Kampları Keşfedin",
      planJourney: "Yolculuğunuzu Planlayın",
      scroll: "Aşağı Kaydır"
    },
    // Why Us Section
    whyUs: {
      tagline: "Neden Biz?",
      title: "Modern Hayata Huzurlu Bir Mola",
      subtitle: "Kamplarımız sadece bir kaçış değil; kadim bilgeliği lüks seyahat deneyimiyle buluşturan, kalıcı bir dönüşümün kapılarını aralıyor."
    },
    // Featured Retreats
    featuredRetreats: {
      tagline: "Öne Çıkan Kamplar",
      title: "Yolculuğunuz Başlıyor",
      viewAll: "Tüm Kampları Görün",
      from: "Başlayan fiyat:",
      learnMore: "Detaylı Bilgi",
      days: "Gün"
    },
    // Our Story
    story: {
      tagline: "Hikayemiz",
      title: "Kadim Bilgelik, Modern Mükemmellik",
      paragraph1: "Omar Sharif Retreats, bilinçli yaşam felsefesini benimseyen, sıradan bir seyahat şirketinden öte bir kuruluştur. Yoga ve kişisel gelişim kamplarımız, modern hayatın stresinden uzaklaşmak ve gerçek bir dönüşüm yaşamak için benzersiz bir fırsat sunar.",
      paragraph2: "ENC Holiday'in profesyonel turizm altyapısıyla, rezervasyondan dönüşe kadar her aşamada size özel ilgi ve avantajlı fiyatlarla kaliteli hizmet sağlıyoruz.",
      quote: "Nefese, doğaya ve iç dengeye geri dönüş.",
      learnStory: "Hikayemizi Keşfedin"
    },
    // CTA Section
    cta: {
      title: "Dönüşüme Başlamaya Hazır mısınız?",
      subtitle: "Size özel mükemmel bir wellness yolculuğu tasarlayalım. Özel kamplardan grup turlarına kadar her adımda yanınızdayız.",
      exploreRetreats: "Kampları Keşfedin",
      contactUs: "Bize Ulaşın"
    },
    // Features
    features: {
      authenticYoga: "Özgün Yoga",
      authenticYogaDesc: "Sertifikalı eğitmenlerle geleneksel yoga pratikleri",
      holisticWellness: "Bütünsel Sağlık",
      holisticWellnessDesc: "Zihin, beden ve ruh dengesi",
      curatedDestinations: "Özenle Seçilmiş Rotalar",
      curatedDestinationsDesc: "Dünyanın dört bir yanından el ile seçilmiş lokasyonlar",
      professionalService: "Profesyonel Hizmet",
      professionalServiceDesc: "A'dan Z'ye lisanslı acente güvencesi"
    },
    // Footer
    footer: {
      description: "Omar Sharif Retreats imzalı dönüşüm odaklı yoga kampları ve profesyonel turizm hizmetleri. ENC Holiday güvencesiyle.",
      quickLinks: "Hızlı Erişim",
      services: "Hizmetlerimiz",
      contact: "İletişim",
      copyright: "© 2026 Omar Sharif Retreats bir ENC Holiday işletmesidir.",
      rights: "Lisanslı Seyahat Acentesi • Tüm Hakları Saklıdır"
    },
    // Contact Page
    contactPage: {
      tagline: "Bizimle İletişime Geçin",
      title: "İletişim",
      subtitle: "Dönüşüm yolculuğunuza başlamak mı istiyorsunuz? Hayalinizdeki wellness deneyimini planlamanız için buradayız.",
      letsConnect: "İletişim Bilgilerimiz",
      address: "Adres",
      phone: "Telefon",
      email: "E-posta",
      sendMessage: "Mesaj Gönderin",
      name: "Adınız Soyadınız",
      namePlaceholder: "Adınızı ve soyadınızı yazın",
      emailPlaceholder: "ornek@email.com",
      phonePlaceholder: "+90 (5XX) XXX XX XX",
      message: "Mesajınız",
      messagePlaceholder: "Hayalinizdeki yoga kampını bize anlatın...",
      send: "Gönder",
      thankYou: "Mesajınız bize ulaştı! En kısa sürede sizinle iletişime geçeceğiz."
    },
    // Retreats Page
    retreatsPage: {
      tagline: "Yoga Kamplarımız",
      title: "Dönüşüm Yolculukları",
      subtitle: "Yoga, meditasyon ve kültürel deneyimlerle kendinizle yeniden buluşmanız için özenle hazırladığımız kamplarımızı keşfedin."
    },
    // About Page
    aboutPage: {
      tagline: "Hakkımızda",
      title: "Hikayemiz",
      subtitle: "Kadim bilgeliğin modern mükemmellikle buluştuğu dönüşüm yolculukları.",
      startJourney: "Yolculuğunuza Başlayın"
    },
    // Services Page
    servicesPage: {
      tagline: "Neler Sunuyoruz?",
      title: "Hizmetlerimiz",
      subtitle: "ENC Holiday'in profesyonel turizm deneyimiyle kapsamlı seyahat ve wellness hizmetleri."
    },
    // Why Us Page
    whyUsPage: {
      tagline: "Neden Biz?",
      title: "Huzurlu Bir Mola",
      subtitle: "Kamplarımız sadece bir kaçış değil; kalıcı dönüşümün kapılarını aralıyor.",
      professionalTitle: "Profesyonel Turizm Deneyimi",
      professionalDesc: "ENC Holiday'in güçlü turizm altyapısıyla; rezervasyondan dönüşe kadar her aşamada anlaşmalı fiyatlar ve kişiye özel ilgiyle kaliteli hizmet garantisi sunuyoruz. Lisanslı acentemiz, yolculuğunuzun her detayını titizlikle ve profesyonelce yönetir.",
      happyTravelers: "Mutlu Misafir",
      destinations: "Destinasyon",
      yearsExperience: "Yıllık Tecrübe"
    },
    // Gallery Page
    galleryPage: {
      tagline: "Görsel Yolculuk",
      title: "Galerimiz",
      subtitle: "Dünyanın dört bir yanındaki kamplarımızdan huzur, dönüşüm ve bağ kurma anlarını keşfedin."
    }
  }
};

export const retreats = {
  en: [
    {
      id: 1,
      title: "Bali Serenity Retreat",
      location: "Ubud, Bali",
      duration: "7 Days",
      price: 1899,
      description: "Immerse yourself in the spiritual heart of Bali with daily yoga sessions, meditation, and traditional healing ceremonies at ancient temples.",
      image: "https://images.unsplash.com/photo-1704253411612-e4deb715dcd8?w=800&q=80"
    },
    {
      id: 2,
      title: "Nepal Himalayan Journey",
      location: "Pokhara, Nepal",
      duration: "10 Days",
      price: 2199,
      description: "Experience spiritual awakening in the shadow of the Himalayas with authentic Nepali yoga traditions, meditation, and mountain treks.",
      image: "https://images.unsplash.com/photo-1681018756175-da11bf6f06ac?w=800&q=80"
    },
    {
      id: 3,
      title: "Thailand Tropical Wellness",
      location: "Koh Samui, Thailand",
      duration: "6 Days",
      price: 1599,
      description: "Find balance on pristine Thai beaches with traditional Thai yoga, meditation, holistic spa treatments, and island exploration.",
      image: "https://images.unsplash.com/photo-1704314315344-cd10b9779ce6?w=800&q=80"
    },
    {
      id: 4,
      title: "Vietnam Mindful Escape",
      location: "Ha Long Bay, Vietnam",
      duration: "8 Days",
      price: 1799,
      description: "Discover inner peace among the mystical limestone karsts of Ha Long Bay with sunrise yoga, meditation cruises, and Vietnamese wellness traditions.",
      image: "https://images.unsplash.com/photo-1661019912526-fb427f1dc77c?w=800&q=80"
    },
    {
      id: 5,
      title: "Zanzibar Paradise Retreat",
      location: "Stone Town, Zanzibar",
      duration: "7 Days",
      price: 2099,
      description: "Unwind on the exotic shores of Zanzibar with beachfront yoga, Swahili cultural immersion, spice tours, and tropical healing therapies.",
      image: "https://images.unsplash.com/photo-1646668072507-b2215b873c70?w=800&q=80"
    },
    {
      id: 6,
      title: "Sri Lanka Ayurveda Journey",
      location: "Ella, Sri Lanka",
      duration: "9 Days",
      price: 1999,
      description: "Embrace ancient Ayurvedic healing in Sri Lanka's lush tea country with personalized wellness programs, yoga, and nature walks.",
      image: "https://images.unsplash.com/photo-1544015759-237f87d55ef3?w=800&q=80"
    },
    {
      id: 7,
      title: "Georgia Mountain Sanctuary",
      location: "Kazbegi, Georgia",
      duration: "6 Days",
      price: 1699,
      description: "Find serenity in the breathtaking Caucasus Mountains with mountain yoga, Georgian traditions, natural hot springs, and scenic hikes.",
      image: "https://images.unsplash.com/photo-1558987830-b9fc9f156565?w=800&q=80"
    },
    {
      id: 8,
      title: "Turkey Cappadocia Dreams",
      location: "Göreme, Turkey",
      duration: "5 Days",
      price: 1499,
      description: "Experience magical yoga sessions among fairy chimneys, hot air balloon meditation at sunrise, and Turkish hammam rituals in Cappadocia.",
      image: "https://images.unsplash.com/photo-1724155733673-c3d68fe5b68d?w=800&q=80"
    }
  ],
  tr: [
    {
      id: 1,
      title: "Bali Huzur Kampı",
      location: "Ubud, Bali",
      duration: "7 Gün",
      price: 1899,
      description: "Bali'nin ruhani atmosferinde her gün yoga seansları, meditasyon ve kadim tapınaklarda geleneksel şifa ritüelleriyle kendinizi yeniden keşfedin.",
      image: "https://images.unsplash.com/photo-1704253411612-e4deb715dcd8?w=800&q=80"
    },
    {
      id: 2,
      title: "Nepal Himalaya Yolculuğu",
      location: "Pokhara, Nepal",
      duration: "10 Gün",
      price: 2199,
      description: "Himalayaların eteklerinde otantik Nepal yoga gelenekleri, meditasyon ve dağ yürüyüşleriyle ruhsal bir uyanış deneyimleyin.",
      image: "https://images.unsplash.com/photo-1681018756175-da11bf6f06ac?w=800&q=80"
    },
    {
      id: 3,
      title: "Tayland Tropikal Wellness",
      location: "Koh Samui, Tayland",
      duration: "6 Gün",
      price: 1599,
      description: "Tayland'ın bozulmamış plajlarında geleneksel Tay yogası, meditasyon, bütünsel spa uygulamaları ve ada keşfiyle iç dengenizi bulun.",
      image: "https://images.unsplash.com/photo-1704314315344-cd10b9779ce6?w=800&q=80"
    },
    {
      id: 4,
      title: "Vietnam Farkındalık Kaçamağı",
      location: "Ha Long Körfezi, Vietnam",
      duration: "8 Gün",
      price: 1799,
      description: "Ha Long Körfezi'nin büyüleyici kireçtaşı kayalıkları arasında gün doğumu yogası, tekne meditasyonları ve Vietnam wellness gelenekleriyle iç huzuru yakalayın.",
      image: "https://images.unsplash.com/photo-1661019912526-fb427f1dc77c?w=800&q=80"
    },
    {
      id: 5,
      title: "Zanzibar Cennet Kampı",
      location: "Stone Town, Zanzibar",
      duration: "7 Gün",
      price: 2099,
      description: "Zanzibar'ın egzotik sahillerinde kumsalda yoga, Svahili kültürü, baharat turları ve tropikal şifa terapileriyle kendinizi şımartın.",
      image: "https://images.unsplash.com/photo-1646668072507-b2215b873c70?w=800&q=80"
    },
    {
      id: 6,
      title: "Sri Lanka Ayurveda Yolculuğu",
      location: "Ella, Sri Lanka",
      duration: "9 Gün",
      price: 1999,
      description: "Sri Lanka'nın yemyeşil çay tepelerinde size özel wellness programları, yoga ve doğa yürüyüşleriyle kadim Ayurveda şifasını deneyimleyin.",
      image: "https://images.unsplash.com/photo-1544015759-237f87d55ef3?w=800&q=80"
    },
    {
      id: 7,
      title: "Gürcistan Dağ Sığınağı",
      location: "Kazbegi, Gürcistan",
      duration: "6 Gün",
      price: 1699,
      description: "Nefes kesen Kafkas Dağları'nda dağ yogası, Gürcü gelenekleri, doğal kaplıcalar ve muhteşem manzaralı yürüyüşlerle huzura kavuşun.",
      image: "https://images.unsplash.com/photo-1558987830-b9fc9f156565?w=800&q=80"
    },
    {
      id: 8,
      title: "Kapadokya Rüyası",
      location: "Göreme, Türkiye",
      duration: "5 Gün",
      price: 1499,
      description: "Peri bacaları arasında büyülü yoga seansları, gün doğumunda balon turu eşliğinde meditasyon ve geleneksel Türk hamamı ritüellerini yaşayın.",
      image: "https://images.unsplash.com/photo-1724155733673-c3d68fe5b68d?w=800&q=80"
    }
  ]
};

export const features = {
  en: [
    {
      id: 1,
      title: "Authentic Yoga",
      description: "Traditional practices from certified instructors",
      icon: "leaf"
    },
    {
      id: 2,
      title: "Holistic Wellness",
      description: "Mind, body, and spirit in harmony",
      icon: "heart"
    },
    {
      id: 3,
      title: "Curated Destinations",
      description: "Handpicked locations worldwide",
      icon: "globe"
    },
    {
      id: 4,
      title: "Professional Service",
      description: "Licensed agency backing every trip",
      icon: "shield"
    }
  ],
  tr: [
    {
      id: 1,
      title: "Özgün Yoga",
      description: "Sertifikalı eğitmenlerle geleneksel yoga pratikleri",
      icon: "leaf"
    },
    {
      id: 2,
      title: "Bütünsel Sağlık",
      description: "Zihin, beden ve ruh dengesi",
      icon: "heart"
    },
    {
      id: 3,
      title: "Özenle Seçilmiş Rotalar",
      description: "Dünyanın dört bir yanından el ile seçilmiş lokasyonlar",
      icon: "globe"
    },
    {
      id: 4,
      title: "Profesyonel Hizmet",
      description: "A'dan Z'ye lisanslı acente güvencesi",
      icon: "shield"
    }
  ]
};

export const navLinks = {
  en: [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Retreats", href: "/retreats" },
    { name: "Services", href: "/services" },
    { name: "Why Us", href: "/why-us" },
    { name: "Gallery", href: "/gallery" },
    { name: "Contact", href: "/contact" }
  ],
  tr: [
    { name: "Ana Sayfa", href: "/" },
    { name: "Hakkımızda", href: "/about" },
    { name: "Yoga Kampları", href: "/retreats" },
    { name: "Hizmetlerimiz", href: "/services" },
    { name: "Neden Biz?", href: "/why-us" },
    { name: "Galeri", href: "/gallery" },
    { name: "İletişim", href: "/contact" }
  ]
};

export const services = {
  en: [
    "Tour Organization",
    "Transfers & Reservations",
    "Flight Tickets",
    "Charter Services",
    "Corporate Events"
  ],
  tr: [
    "Tur Organizasyonu",
    "Transfer ve Rezervasyon",
    "Uçak Bileti",
    "Özel Charter Hizmetleri",
    "Kurumsal Etkinlikler"
  ]
};

export const quickLinks = {
  en: [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Retreats", href: "/retreats" },
    { name: "Services", href: "/services" },
    { name: "Contact", href: "/contact" }
  ],
  tr: [
    { name: "Ana Sayfa", href: "/" },
    { name: "Hakkımızda", href: "/about" },
    { name: "Yoga Kampları", href: "/retreats" },
    { name: "Hizmetlerimiz", href: "/services" },
    { name: "İletişim", href: "/contact" }
  ]
};

export const contactInfo = {
  address: "Orta Mh. Hasan Tahsin Kirali Cd. No: 2/A, 61600 Sürmene/Trabzon",
  phone: "+90 544 782 95 60",
  email: "omer.serif@encholiday.com",
  whatsapp: "905447829560"
};

export const galleryImages = [
  // Second row images (now first row)
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/ihqz5031_WhatsApp%20Image%202026-01-29%20at%2010.38.38.jpeg",
    alt: "Yoga pose at Bali rice terraces",
    category: "yoga"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/ys91ms2g_WhatsApp%20Image%202026-01-29%20at%2011.08.10.jpeg",
    alt: "Meditation at ancient Bali temple",
    category: "experiences"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/yxjowvcc_Screenshot%202026-02-03%20212544.jpg",
    alt: "Sunrise yoga session",
    category: "yoga"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/80wiysn8_Screenshot%202026-02-03%20212655.jpg",
    alt: "Group meditation practice",
    category: "retreats"
  },
  // First row images (now second row)
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/klwfwujj_IMG-20251022-WA0026.jpg",
    alt: "Yoga retreat group with flower mandala",
    category: "retreats"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/4we2n8hx_IMG-20251022-WA00299.JPG",
    alt: "Aerial view of yoga session with flower mandala",
    category: "retreats"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/cvp44ew5_WhatsApp%20Image%202025-03-16%20at%2014.47.35_05ded08a.jpg",
    alt: "Yoga instructor in namaste pose",
    category: "instructors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/3llmr56a_WhatsApp%20Image%202026-01-29%20at%2010.37.25%20%283%29.jpeg",
    alt: "Water purification ritual at Bali temple",
    category: "experiences"
  },
  // Third row images (unchanged)
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/ckwz3ifd_Screenshot%202026-02-03%20212732.jpg",
    alt: "Peaceful retreat moment",
    category: "experiences"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_yoga-retreat-2/artifacts/ej5z3yna_Screenshot%202026-02-03%20212845.jpg",
    alt: "Wellness journey highlights",
    category: "retreats"
  },
  // Existing gallery images
  {
    src: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80",
    alt: "Yoga meditation at sunset",
    category: "yoga"
  },
  {
    src: "https://images.unsplash.com/photo-1545389336-cf090694435e?w=600&q=80",
    alt: "Yoga pose in nature",
    category: "yoga"
  },
  {
    src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80",
    alt: "Group yoga session",
    category: "retreats"
  },
  {
    src: "https://images.unsplash.com/photo-1704253411612-e4deb715dcd8?w=600&q=80",
    alt: "Bali temple",
    category: "destinations"
  },
  {
    src: "https://images.unsplash.com/photo-1681018756175-da11bf6f06ac?w=600&q=80",
    alt: "Nepal mountains",
    category: "destinations"
  },
  {
    src: "https://images.unsplash.com/photo-1704314315344-cd10b9779ce6?w=600&q=80",
    alt: "Thailand beach",
    category: "destinations"
  }
];
